import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=30d53bfc&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=30d53bfc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30d53bfc"

export default script